<div class="section-header">
<!--    <app-info-icon-button-->
<!--        [model]="{ title: 'Information',-->
<!--                   messages: ['text is not defined yet'],-->
<!--                   dialogHeight: 100}">-->
<!--    </app-info-icon-button>-->
    <div class="title">
        Kommentare
    </div>
</div>


<div>

    <bd-labeled-textarea label="Geräte, Zubehör und Full Service Pack Kommentar"
                         placeholder="Kommentar für die Geräte, Zubehör und Full Service Pack eingeben"
                         [maxlength]="'1000'"
                         limitTo="1000"
                         rows="5"
                         name="commentHardware" [(ngModel)]="model.project.commentHardware"
                         #commentHardwareNgModel="ngModel">
    </bd-labeled-textarea>
    <bd-input-error-viewer [ngModelRef]="commentHardwareNgModel">
    </bd-input-error-viewer>

    <bd-labeled-textarea label="Verbrauchsmaterial Kommentar"
                         placeholder="Kommentar für Verbrauchsmaterial eingeben"
                         [maxlength]="'1000'"
                         limitTo="1000"
                         rows="5"
                         name="commentSupplies" [(ngModel)]="model.project.commentSupplies"
                         #commentSuppliesNgModel="ngModel">
    </bd-labeled-textarea>
    <bd-input-error-viewer [ngModelRef]="commentSuppliesNgModel">
    </bd-input-error-viewer>

</div>

